import {GqlModel, GqlModelOperator, GqlMutationModel, GqlQueryModel} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../json.model";
import {SuccessResultGqlModel} from "../graphql/common.gql-model";

export class SessionTimeoutGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<SessionTimeoutGqlModel> =
    GqlModel.buildMapper(SessionTimeoutGqlModel, "sessionTimeout");

  static query: any = gql`
    subscription sessionTimeout {
      sessionTimeout {
        expiry
      }
    }
  `;

  @jsonProperty("date") expiry: Date;
}

export class RenewSessionGqlModel extends GqlMutationModel {
  static mapper: GqlModelOperator<SuccessResultGqlModel> = GqlModel.buildMapper(SuccessResultGqlModel, "renewSession");

  static query: any = gql`
    mutation renewSession {
      renewSession {
        success
      }
    }
  `;

  @jsonProperty("booleanTrue") renew: boolean;
}
